import Button from '@material-ui/core/Button';
import { useFormikContext } from 'formik';
import { useSubmitButtonDisabled } from 'components/common/formik';
import { FULL_ACCESS_IMPLEMENTATION } from 'components/common/permissions';
import { useHasPermission } from 'hooks';
import { useIsImport } from '../hooks';

const EndAdornmentUpdateButton = () => {
  const { handleSubmit } = useFormikContext();
  const hasPerm = useHasPermission([FULL_ACCESS_IMPLEMENTATION]);
  const disabled = useSubmitButtonDisabled();
  const isImport = useIsImport();

  return !isImport ? (
    <Button
      color="primary"
      disabled={hasPerm ? disabled : true}
      onClick={handleSubmit}
      variant="contained"
    >
      Update
    </Button>
  ) : null;
};

export default EndAdornmentUpdateButton;
